<div class="container-fluid" [ngClass]="this.updatedtheme === 'dark' ? 'bg-colourD' : 'bg-colourL'">

    <div class="container-fluid row d-flex justify-content-end "
        [ngClass]="this.updatedtheme === 'dark' ? 'headertextD' : 'headertextL'">
        <a class="brand-link ct_logo_collape">
            <img *ngIf="updatedtheme === 'dark'" class="pl-4 et_logo_1" [src]="dashboardLogoUrl" alt="Ekobon Logo"
                height="33" />
            <img *ngIf="updatedtheme !== 'dark'" class="pl-4 et_logo_1" [src]="dashboardLogoUrl" alt="Ekobon Logo"
                height="33" />
            <!-- <img *ngIf="updatedtheme === 'dark'" class="pl-4 et_logo_1" src="assets/img/ekobonL.png" alt="Ekobon Logo"
                height="33" />


            <img *ngIf="updatedtheme !== 'dark'" class="pl-4 et_logo_1" src="assets/img/ekobonL.png" alt="Ekobon Logo"
                height="33" /> -->

        </a>
        <div class="col d-flex justify-content-end d-none">
            <div class="row align-items-center">
                <div class="mr-4  pl-3 pointer">
                    <div>
                        <!-- <app-notifications class="mt-0"></app-notifications> -->
                    </div>
                </div>

                <div class="my-3 mr-2 pt-0 px-2 border border-dark rounded flex-row ct_select_dropdown_btn"
                    [ngClass]="isActiveLabel() ? 'd-flex' : 'd-none'">
                    <img class="pr-2 pointer" [src]="uploadedImageUrl" height="30vh " alt="" />
                    <p *ngIf="loginInfo.facilityID === 0" class="mr-2 pt-1 pointer">
                        {{ loginInfo.companyName }}
                    </p>
                    <!-- <p *ngIf="loginInfo.facilityID !== 0" class="mr-2 pt-1 pointer">
                        {{ loginInfo.companyName }} ->
                        {{ loginInfo.facilityName }} ->
                        {{ loginInfo.userName }}
                    </p> -->
                    <p class="mr-2 pt-1 pointer ct_filter_dropdown">
                        <ng-container *ngIf="showFacility && facilitygrouplist.length > 0">
                            <p-dropdown class="et_header_drop_down_560" *ngIf="loginInfo.role !== 'Platform Admin'"
                                [options]="facilitygrouplist" optionLabel="AssestType" optionValue="id"
                                styleClass="headerFacility" [(ngModel)]="selectedFacilityID"
                                [ngModelOptions]="{ standalone: true }" (onChange)="onFacilityChange()">

                                <ng-template let-option pTemplate="item">
                                    <div class="d-flex justify-content-between">
                                        <div>{{ option.AssestType }}</div>
                                        <div class="d-flex justify-content-end pt-1 ml-1">
                                            <i class="fa fa-user"></i>
                                        </div>
                                    </div>
                                </ng-template>

                            </p-dropdown>
                        </ng-container>



                        <ng-container *ngIf="showGroup">
                            <p-dropdown class="et_header_drop_down_560"
                                *ngIf="loginInfo.role !== 'Platform Admin' && facilitysubgrouplist.length > 0"
                                [options]="facilitysubgrouplist" optionLabel="name" optionValue="id"
                                styleClass="headerFacility" [(ngModel)]="selectedGroupID"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="onGroupChnage()">
                                <ng-template let-option pTemplate="item">
                                    <div class="d-flex justify-content-between">
                                        <div>{{ option.name }}</div>
                                        <div class="d-flex justify-content-end pt-1 ml-1">
                                            <i class="fa fa-user"></i>
                                        </div>
                                    </div>

                                </ng-template>
                            </p-dropdown>

                        </ng-container>
                    </p>
                </div>
                <div class="ct_log_out_btn d-flex flex-row">
                    <!-- <div>
                        <i class="pi  pi-user pt-1 pl-1"></i>
                    </div> -->

                    <!-- <p-menu #menu icon="pi pi-bars" [model]="ProfileMenu" [popup]="true"></p-menu>
                    <div (click)="toggleMenu($event)">
                        <i class="pi  pi-user pt-1 pl-1"></i>
                    </div> -->

                    <a (click)="getRedirectLink()" class="mx-3 pt-0 pointer d-flex headertextL">


                        <i class="fa fa-book" aria-hidden="true"></i></a>

                    <a (click)="logout()" class="mr-2 pt-0 pointer d-flex" [ngClass]="
                            this.updatedtheme === 'dark'
                                ? 'headertextD'
                                : 'headertextL'
                        ">
                        <div class="">
                            <i class="pi pi-power-off pt-1 pl-1"></i>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>